$shm_hitalama_notifications $mol_view
	sub <= rows /
		<= Row* $mol_view
			attr *
				^
				notification_type <= type* \info
			sub /
				<= Content* $mol_view
					sub /
						<= Title_holder* $mol_view
							sub <= notification_title_visible* /
								<= Title* $mol_view
									sub / <= notification_title* \
						<= Message* $mol_view
							sub / <= message* \
				<= Close* $mol_button_minor
					hint \Закрыть
					click? <=> close*? null
					sub /
						<= Close_icon* $mol_icon_close
